import { render } from "./DocumentClassExportStates.vue?vue&type=template&id=7f19bab7&scoped=true&ts=true"
import script from "./DocumentClassExportStates.vue?vue&type=script&lang=ts"
export * from "./DocumentClassExportStates.vue?vue&type=script&lang=ts"

import "./DocumentClassExportStates.vue?vue&type=style&index=0&id=7f19bab7&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f19bab7"]])

export default __exports__